import styled from 'styled-components';

export const OrderCellSpan = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: blue;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PloomesOrderClamp = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-height: 2.8em;
`;

export const ExitOrEntry = styled.div`
  display: flex;
  align-items: center;
  gap: .5rem;
`